var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",style:(_vm.customStyle)},[(_vm.showIcon)?_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":require("@/assets/titleicon.svg")}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }